import React from 'react';
import { linkConfidenceItems } from '../utils/linkConfidence';

/**
 * Link confidence: how each phase was tied to its GAM request (exact / strong /
 * weak). Shared by the Lifecycle and Slots tabs; logic in utils/linkConfidence.js.
 */

const META = {
  exact: { label: 'Exact', dot: '●', fg: 'var(--success-text)', bg: 'var(--success-bg)', bd: 'var(--success-border)',
    desc: 'Exact match — cryptographic or 1:1 structural join (correlator / xai / sai / sigh / amzn_b token / cache id). No time guessing.' },
  strong: { label: 'Strong', dot: '◐', fg: 'var(--warn-text)', bg: 'var(--warn-bg)', bd: 'var(--warn-border)',
    desc: 'Strong match — structural (ad unit / size / gpid / Prebid-anchored) but not provably unique.' },
  weak: { label: 'Weak', dot: '○', fg: 'var(--error-text)', bg: 'var(--error-bg)', bd: 'var(--error-border)',
    desc: 'Weak match — linked on a time window only. On busy pages this may be the wrong slot; verify against the raw request.' },
};

export function ConfidenceChip({ level, prefix = '', style = {} }) {
  const m = level && META[level];
  if (!m) return null;
  return (
    <span title={m.desc} data-confidence={level} style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      fontSize: 9.5, fontWeight: 700, lineHeight: '14px',
      padding: '1px 6px', borderRadius: 10,
      color: m.fg, background: m.bg, border: `1px solid ${m.bd}`,
      whiteSpace: 'nowrap', ...style,
    }}>
      {m.dot} {prefix}{m.label}
    </span>
  );
}

/** One line: "LINK CONFIDENCE  Prebid ● Exact  APS ◐ Strong  Imp ○ Weak nearest in time". */
export function LinkConfidenceRow({ phases, style = {} }) {
  const items = linkConfidenceItems(phases);
  if (!items.length) return null;
  return (
    <div data-testid="link-confidence" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, ...style }}>
      <span style={{ fontSize: 9.5, color: 'var(--muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
        Link confidence
      </span>
      {items.map(({ key, label, level, tier, matchLabel }) => (
        <span key={key} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }} title={tier ? `matched by ${tier}` : undefined}>
          <span style={{ fontSize: 10, color: 'var(--muted)' }}>{label}</span>
          <ConfidenceChip level={level} />
          {matchLabel && <span style={{ fontSize: 9.5, color: 'var(--muted)' }}>{matchLabel}</span>}
        </span>
      ))}
    </div>
  );
}
